import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import AreasList from './AreasList';
import AreaCreate from './AreaCreate';
import AreaEdit from './AreaEdit';

function Areas() {
  return (
    <Routes>
      <Route path="/" element={<AreasList />} />
      <Route path="/create" element={<AreaCreate />} />
      <Route path="/edit/:id" element={<AreaEdit />} />
      <Route path="*" element={<Navigate to="/dashboard/areas" replace />} />
    </Routes>
  );
}

export default Areas; 